import React from 'react';
import Metric from "./Metric";

export default function Metrics({metrics}) {
    return (
        <div className="card-deck">
            {metrics && metrics.map((metric, idx) => (

                <Metric key={idx}
                        title={metric.title}
                        subTitle={metric?.subTitle || ''}
                        number={metric.number}
                        unit={metric.unit || null}
                        icon={metric.icon}
                        variant={metric.variant}
                        onClick={metric.onClick}
                />

            ))}
        </div>
    );
}
